import { render, staticRenderFns } from "./PagamentoDocumentos.vue?vue&type=template&id=27bb529e"
import script from "./PagamentoDocumentos.vue?vue&type=script&lang=js"
export * from "./PagamentoDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports